import CAMERONPNG from '../../../assets/faces/Cameron.png';
import DIANNEPNG from '../../../assets/faces/Dianne.png';
import ELEANORPNG from '../../../assets/faces/Eleanor.png';
import JANEPNG from '../../../assets/faces/Jane.png';
import LESSIEPNG from '../../../assets/faces/Leslie.png';
import theme from '../../../theme';

const colorNameInDesc = (name: string, desc: string) => {
  const nameIndex = desc.indexOf(name);
  const beforeName = desc.substring(0, nameIndex);

  const afterName = desc.substring(nameIndex + name.length);

  return (
    <div>
      {beforeName}
      <span style={{ color: theme.colors.primary }}>{name}</span>
      {afterName}
    </div>
  );
};

export const facesData = [
  {
    name: 'Cameron Williamson',
    position: 'Founder & CEO',
    desc: colorNameInDesc(
      'Cameron Williamson',
      'With a background in Building Construction, Cameron Williamson founded Escape Plan with a vision to revolutionize the way escape planning is done. ',
    ),
    img: CAMERONPNG,
  },
  {
    name: 'Leslie Alexander',
    position: 'Chief Technology Officer',
    desc: colorNameInDesc(
      'Leslie Alexander',
      'As our technology guru, Leslie Alexander oversees the development of our platform, ensuring it remains cutting-edge and user-friendly.',
    ),
    img: LESSIEPNG,
  },
  {
    name: 'Eleanor Pena',
    position: 'Safety Engineer',
    desc: colorNameInDesc(
      'Eleanor Pena',
      'With years of experience in safety engineering, Eleanor Pena ensures that our escape plans meet the highest standards of safety and compliance.',
    ),
    img: ELEANORPNG,
  },
  {
    name: 'Dianne Russell',
    position: 'Customer Success Manager',
    desc: colorNameInDesc(
      'Dianne Russell',
      'Dianne Russell is dedicated to ensuring that our clients have a seamless experience with Escape Plan, from onboarding to ongoing support.',
    ),
    img: DIANNEPNG,
  },
  {
    name: 'Jane Cooper',
    position: 'Design Lead',
    desc: colorNameInDesc(
      'Jane Cooper',
      'Responsible for the visual aspects of our platform, Jane Cooper ensures that our interface is intuitive and engaging for users.',
    ),
    img: JANEPNG,
  },
];
